<template>
    <div class="panel-body main-content row">
        <div class="contentLeft">
            <div class="top_content">
                <p>ログアウトします。</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { Component, Vue } from 'vue-property-decorator';

    @Component
    export default class Logout extends Vue {
        created(){
            this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie));
            location.href = String(process.env.VUE_APP_LOCATION_AUTH_PAGE);
        }
    }
</script>

<style scoped>

</style>